// Substituted at build (webpack/Vite define) or bundle deploy time.
declare global {
  var REDO_ADMIN_SERVER_URL: string | undefined;
  var REDO_CHAT_WIDGET_URL: string | undefined;
  var REDO_MERCHANT_APP_URL: string | undefined;
}

export const REDO_ADMIN_SERVER_URL =
  globalThis.REDO_ADMIN_SERVER_URL || "http://localhost:8005/";

export const REDO_MERCHANT_APP_URL =
  globalThis.REDO_MERCHANT_APP_URL || "http://localhost:3003";

const AMPLITUDE_REPLAY_BASE =
  "https://app.amplitude.com/analytics/redo/session-replay/project/800590/search/replay";

export function getAnalyticsReplayUrl(
  sessionId: string | null | undefined,
): string | null {
  const normalized = sessionId?.trim();
  if (!normalized) {
    return null;
  }
  return `${AMPLITUDE_REPLAY_BASE}?sessionReplayId=${normalized}`;
}

export const REDO_CHAT_WIDGET_URL =
  globalThis.REDO_CHAT_WIDGET_URL || "http://localhost:3008";
